import { Component, OnInit, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { SystemConfigValue } from '../admin/system-configuration/shared/models/system-config-value';
import { getACLicenseStatus, getSystemConfigurations, GetUserPermissionList } from '../state';
import { State } from '../state/app.state';
import { LobbyService } from './shared/services/lobby.service';
import LobbyTab from './shared/models/lobby-tab';
import { TranslationLoaderFacade } from '../admin/localization/translation-loader.facade';
import { Router } from '@angular/router';
import { readCastedValue } from '../shared/utils/read-casted-value.function';

@Component({
  selector: 'app-lobby',
  templateUrl: './lobby.component.html',
  styleUrls: ['./lobby.component.scss']
})

export class LobbyComponent implements OnInit, OnDestroy {
  subscriptions = new Subscription();
  active: any
  public userPermissionList: number[] = [];
  public staffColumnText: string = '';
  isLocationChange: boolean = false;
  tabState: LobbyTab | null;
  isACLicenseEnabled$: Observable<boolean> = new Observable<boolean>();

  constructor(private store: Store<State>, private lobbyService: LobbyService, private router: Router, private translationLoaderFacade: TranslationLoaderFacade) {
    this.tabState = this.router.getCurrentNavigation()?.extras.state?.tab ?? null;
    this.router.onSameUrlNavigation = 'reload';
  }

  ngOnInit() {
    this.store.select(GetUserPermissionList).subscribe((allUserPermissions) => {
      if (!allUserPermissions) {
        throw Error('allUserPermissions is undefined!')
      }
      this.userPermissionList = allUserPermissions;
    });
    this.isACLicenseEnabled$=this.store.select(getACLicenseStatus);

    this.subscriptions.add(
      this.store.select(getSystemConfigurations).subscribe(
        (configurations) => {
          const lobbyConfigurations = configurations.filter(c => c.configurationGroup === 'LobbySettings');
          if (lobbyConfigurations.length > 0) {
            const defaultLobbyTab = readCastedValue(lobbyConfigurations.find(ac => ac.configurationName === 'DefaultLobbyTab'));
            const staffColumnTextValue = readCastedValue(lobbyConfigurations.find(ac => ac.configurationName === 'StaffStatusDisplayText'));
            
            if (typeof staffColumnTextValue === 'string') {
              this.staffColumnText = staffColumnTextValue;
            }

            this.lobbyService.getLocationChangeFlag.subscribe(flag => this.isLocationChange = flag);
            if(!this.isLocationChange){

            switch (defaultLobbyTab) {
              case '1':
                this.active = 1;
                break;
              case '2':
                this.active = 2;
                break;
              //case 'Central Views':
              case '3':
                if(this.userPermissionList?.includes(47)){
                  this.active = 3;
                }
                else{
                  this.active = 1;
                }
                break;
              case '4':
                if(this.userPermissionList?.includes(47)){
                  this.active = 3;
                }
                else{
                  this.active = 1;
                }
                break;
              case '5':
                if(this.userPermissionList?.includes(47)){
                  this.active = 3;
                }
                else{
                  this.active = 1;
                }

                break;
              default:
                this.active = 1;
                break;
            }
          }
          this.lobbyService.changeLocationChangeFlag(false);
          }
        }
      )
    );

    this.subscriptions.add(this.router.events.subscribe(() => {
      const tabStateOnSamePageNav = this.router.getCurrentNavigation()?.extras.state?.tab;
      if (tabStateOnSamePageNav != null) this.setTab(tabStateOnSamePageNav);
    }));

    if (this.tabState != null) {
      this.setTab(this.tabState);
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
    this.router.onSameUrlNavigation = 'ignore';
  }

  private setTab(lobbyTab: LobbyTab) {
    this.active = lobbyTab
  }

}
